import { render } from "./AdminGallery.vue?vue&type=template&id=0e488c9a"
import script from "./AdminGallery.vue?vue&type=script&lang=js"
export * from "./AdminGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__